import { Applicant } from 'types/graphql'

import DNButton from 'src/components/Buttons/Button/DNButton'
import { useEmailModalContext } from 'src/context/EmailModalContext'

import SidebarActivityLogs from './SidebarActivityLogs'

// Sidebar Email tab — renders the shared activity-log thread (EMAIL rows as
// SMS-style bubbles via EmailLog) instead of the old thread-card list. There
// is no inline email composer in the thread, so the compose entry point stays
// as the "Send email" button below, opening the full compose modal.
const EmailTab = ({ applicant }: { applicant: Applicant }) => {
  const { handleOpen: openEmailModal } = useEmailModalContext()

  return (
    <div className="flex flex-1 flex-col gap-2 overflow-hidden">
      <SidebarActivityLogs applicant={applicant} communication="EMAIL" />
      {applicant.email && (
        <DNButton
          variant="secondary"
          onClick={() => {
            openEmailModal({
              applicantId: applicant.applicantId,
              defaultTo: applicant.email,
            })
          }}
        >
          Send email
        </DNButton>
      )}
    </div>
  )
}

export default EmailTab
